var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_854_3481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 23,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0287 9.99454H12.7507V14.2561H18.6668C18.1153 16.9635 15.8091 18.5177 12.7507 18.5177C9.1409 18.5177 6.23299 15.6098 6.23299 12C6.23299 8.39017 9.1409 5.48225 12.7507 5.48225C14.305 5.48225 15.7088 6.03376 16.8118 6.93621L20.0205 3.72748C18.0652 2.02284 15.5584 0.969971 12.7507 0.969971C6.63408 0.969971 1.7207 5.88335 1.7207 12C1.7207 18.1167 6.63408 23.03 12.7507 23.03C18.2657 23.03 23.2794 19.0191 23.2794 12C23.2794 11.3482 23.1791 10.6463 23.0287 9.99454Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_854_3481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.718506 18.5178V5.4823L9.24171 12L0.718506 18.5178Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_854_3481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 23,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0287 9.99454H12.7507V14.2561H18.6668C18.1153 16.9635 15.8091 18.5177 12.7507 18.5177C9.1409 18.5177 6.23299 15.6098 6.23299 12C6.23299 8.39017 9.1409 5.48225 12.7507 5.48225C14.305 5.48225 15.7088 6.03376 16.8118 6.93621L20.0205 3.72748C18.0652 2.02284 15.5584 0.969971 12.7507 0.969971C6.63408 0.969971 1.7207 5.88335 1.7207 12C1.7207 18.1167 6.63408 23.03 12.7507 23.03C18.2657 23.03 23.2794 19.0191 23.2794 12C23.2794 11.3482 23.1791 10.6463 23.0287 9.99454Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_854_3481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.718506 5.4823L9.24171 12L12.7513 8.94172L24.784 6.98639V-0.0327148H0.718506V5.4823Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_854_3481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 23,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0287 9.99454H12.7507V14.2561H18.6668C18.1153 16.9635 15.8091 18.5177 12.7507 18.5177C9.1409 18.5177 6.23299 15.6098 6.23299 12C6.23299 8.39017 9.1409 5.48225 12.7507 5.48225C14.305 5.48225 15.7088 6.03376 16.8118 6.93621L20.0205 3.72748C18.0652 2.02284 15.5584 0.969971 12.7507 0.969971C6.63408 0.969971 1.7207 5.88335 1.7207 12C1.7207 18.1167 6.63408 23.03 12.7507 23.03C18.2657 23.03 23.2794 19.0191 23.2794 12C23.2794 11.3482 23.1791 10.6463 23.0287 9.99454Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_854_3481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.718506 18.5178L15.7595 6.98639L19.7202 7.48776L24.784 -0.0327148V24.0328H0.718506V18.5178Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_854_3481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 23,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0287 9.99454H12.7507V14.2561H18.6668C18.1153 16.9635 15.8091 18.5177 12.7507 18.5177C9.1409 18.5177 6.23299 15.6098 6.23299 12C6.23299 8.39017 9.1409 5.48225 12.7507 5.48225C14.305 5.48225 15.7088 6.03376 16.8118 6.93621L20.0205 3.72748C18.0652 2.02284 15.5584 0.969971 12.7507 0.969971C6.63408 0.969971 1.7207 5.88335 1.7207 12C1.7207 18.1167 6.63408 23.03 12.7507 23.03C18.2657 23.03 23.2794 19.0191 23.2794 12C23.2794 11.3482 23.1791 10.6463 23.0287 9.99454Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_854_3481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7843 24.0328L9.24203 12L7.23657 10.4959L24.7843 5.4823V24.0328Z",
    fill: "#EA4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.375ece3a0bde5114ca447695c38570d4.svg";
export { ForwardRef as ReactComponent };